import ModalManager from 'react-overlays/lib/ModalManager'
import { useEffect } from 'react'

// Default ModalManager pads <body> for scrollbar removal, but the viewport
// scrollbar is on <html>, so the padding becomes a white gutter. Opt out and
// lock the real scroll root instead.
export const appModalManager = new ModalManager({
  handleContainerOverflow: false,
})

let lockCount = 0
let prevHtmlOverflow = ''
let prevBodyOverflow = ''

export function lockPageScroll () {
  if (typeof document === 'undefined') return
  if (lockCount === 0) {
    prevHtmlOverflow = document.documentElement.style.overflow
    prevBodyOverflow = document.body.style.overflow
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
  }
  lockCount += 1
}

export function unlockPageScroll () {
  if (typeof document === 'undefined' || lockCount === 0) return
  lockCount -= 1
  if (lockCount === 0) {
    document.documentElement.style.overflow = prevHtmlOverflow || ''
    document.body.style.overflow = prevBodyOverflow || ''
    prevHtmlOverflow = ''
    prevBodyOverflow = ''
  }
}

/** Mount while a modal is open to lock page scroll without the white gutter. */
export function ModalScrollLock ({ show }) {
  useEffect(() => {
    if (!show) return undefined
    lockPageScroll()
    return () => unlockPageScroll()
  }, [show])
  return null
}
